import { Menu, X } from "lucide-react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import imgAkaramRadio21 from "../assets/88a72e061294cd37ffeb1899b21ccf2c92fbc0f4.png";

export default function NavBar() {
    const {siteData: data} = useAuth()
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const navLinks = 
    [
      {lable: "Home", to: "home"},
      {lable: "Schedule", to: "schedule"},
      {lable: "Shows", to: "shows"},
      {lable: "History", to: "history"},
      {lable: "Contact", to: "contact"},
    ]
            

    const navigate = useNavigate();

    const scrollToSection = (sectionId: string) => {
        if (window.location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
            const element = document.getElementById(sectionId);
            if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            }
        }, 100);
        } else {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
        }
    };

  return (
    <nav className="absolute top-0 left-0 right-0 z-50 flex justify-center pt-navbar px-4">
      <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl px-6 py-4 w-full max-w-5xl flex items-center justify-between">
        {/* Logo Section */}
        <div className="flex items-center gap-3">
            <Link to={`/`} className="w-14 h-18 relative">
                <img
                    src={data ? data?.headerLogo : imgAkaramRadio21}
                    alt="Akaram Radio"
                    className="w-full h-full object-contain"
                />
            </Link>
          <Link to={`/`} className="text-white font-semibold text-lg tracking-tight hidden sm:block">
            {data ? data?.name : "Akaram Radio"}
          </Link>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8">
          {
            navLinks.map((e,i)=>{
              return <button key={i} onClick={()=>{scrollToSection(e.to);}} className="text-white font-medium hover:text-cyan-300 transition-colors">{e.lable}</button>
            })
          }
        </div>

        {/* CTA & Mobile Menu Toggle */}
        <div className="flex items-center gap-4">
          <button className="bg-white text-black px-5 py-2 rounded-full font-medium text-sm hover:bg-cyan-50 transition-colors">
            Listen Live
          </button>
          
          <button 
            className="md:hidden text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="absolute top-full left-4 right-4 mt-2 bg-[#042033] border border-white/10 rounded-2xl p-4 flex flex-col gap-4 md:hidden shadow-xl">
          {
            navLinks.map((e,i)=>{
              return <button key={i} onClick={()=>{scrollToSection(e.to); setIsMenuOpen(!isMenuOpen)}} className="text-white font-medium text-left py-2 border-b border-white/10">{e.lable}</button>
            })
          }
        </div>
      )}
    </nav>
  );
}
